import { render, staticRenderFns } from "./PreTransfer.vue?vue&type=template&id=2b1f9d08&scoped=true"
import script from "./PreTransfer.vue?vue&type=script&lang=js"
export * from "./PreTransfer.vue?vue&type=script&lang=js"
import style0 from "./PreTransfer.vue?vue&type=style&index=0&id=2b1f9d08&prod&lang=scss&scoped=true"
import style1 from "./PreTransfer.vue?vue&type=style&index=1&id=2b1f9d08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1f9d08",
  null
  
)

export default component.exports